import React, { FC } from 'react';
import MaintenanceErrorIcon from "@/components/icons/MaintenanceError";


interface MaintenanceProps { }

const Maintenance: FC<MaintenanceProps> = () => {
  return (
    <div className='Maintenance flex flex-col gap-8 items-center justify-center min-h-[90vh] text-center' data-testid='Maintenance'>
      <MaintenanceErrorIcon />
      <div className="text-black text-3xl font-medium mt-6">We are updating booking experiences for you</div>
      <div className='text-black text-lg font-medium leading-[27px]'>
        Hold tight, we'll be back soon.
      </div>
    </div>
  );
};



export default Maintenance;
